<template>
  <v-container>
    <div class="page">
      <div class="title">Demo data files for the following models:</div>
      <div v-for="(item, index) in data" :key="index">
        <div class="section-second-title">{{ item.title }}</div>
          <v-divider class="line"></v-divider>
          <div v-for="(sub, index) in item.subItems" :key="index">
          <div class="item-context">
            <div class="item-word">
              {{sub.subTitle}}: {{sub.description}}
            </div>
            <v-btn variant="tonal" color="info" class="mr-2" size="x-small" @click="download_pdf(sub.router)">Download</v-btn>
          </div>
          <v-divider class="line"></v-divider>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      data: [{
        title: 'All modules',
        subItems: [{
          subTitle: 'All modules',
          description: 'all demo data',
          router: 'All',
        }]
      }, {
        title: 'E-STAT',
        subItems: [{
          subTitle: 'ExpoStatistics',
          description: 'describe the data',
          router: 'ExpoStatistics',
        }, {
          subTitle: 'ExpoCros',
          description: 'analyze the cross-sectional data',
          router: 'ExpoCros',
        }, {
          subTitle: 'ExpoMultiomics',
          description: 'analyze the data of multi-omics',
          router: 'ExpoMultiomics',
        }, {
          subTitle: 'ExpoPanel',
          description: 'analyze the data of panel study',
          router: 'ExpoPanel',
        }, {
          subTitle: 'ExpoSurvival',
          description: 'analyze the censored data',
          router: 'ExpoSurvival',
        }, {
          subTitle: 'ExpoMediation',
          description: 'screening the mediation pathway',
          router: 'ExpoMediation',
        }, {
          subTitle: 'ExpoMixEffect',
          description: 'analyzing the effect of mixture exposure',
          router: 'ExpoMixEffect',
        }, {
          subTitle: 'ExpoStatLink',
          description: 'explore the statistical explanation',
          router: 'ExpoStatLink',
        }]
      }, {
        title: 'E-DB',
        subItems: [{
          subTitle: 'ExpoDB',
          description: 'support the ExposomeX platform',
          router: 'ExpoDB',
        }]
      }, {
        title: 'E-MS',
        subItems: [{
          subTitle: 'ExpoNontarget',
          description: 'analyze the non-targeted from HRMS',
          router: 'ExpoNontarget',
        }]
      }, {
        title: 'E-META',
        subItems: [{
          subTitle: 'ExpoMeta',
          description: 'provide the summary of the previous publications',
          router: 'ExpoMeta',
        }]
      }, {
        title: 'E-BIO',
        subItems: [{
          subTitle: 'ExpoBioLink',
          description: 'explore the biological explanation',
          router: 'ExpoBioLink',
        }]
      }, {
        title: 'E-VIZ',
        subItems: [{
          subTitle: 'ExpoViz',
          description: 'visualize the data',
          router: 'ExpoViz',
        }]
      }]
    };
  },
  methods: {
    async download_pdf(name){
      let a = document.createElement('a')
      a.href ="http://www.exposomex.cn/exposome/Downloadrar100/" + name
      a.target='_blank'
      a.click()
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-left: 2em;
}
.title {
  font-weight: 600;
  font-size: $webpage-large-font-size;
  margin: 1em 0 0.6em;
}
.item-context {
  display: flex;
  gap: 60px;
  align-items: center;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.section-second-title {
  font-weight: bold;
  margin: 0.6em 0 0.2em;
}
.line {
  width: 90%;
}
.item-word {
  min-width: 800px;
}
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line {
    width: 100%;
  }
  .item-word {
    min-width: 0;
  }
  .item-context {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .page {
    margin: 0;
  }
  .line {
    width: 100%;
  }
  .item-context {
    display: flex;
    gap: 1em;
    align-items: center;
    justify-content: space-between;
  }
  .item-word {
    min-width: 0;
  }
}
</style>